import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from '../../utilities/props';
export default function () {
    return React.createElement('div', _.assign({}, cleanProps(this.props)), '\r\n', this.props.children, '\r\n');
}